import { DeviceIdentificationType } from '@quadminds/shared/tracking-system';

export interface IGetDeviceDistanceTraveledInputDto {
    identificationType?: DeviceIdentificationType;
    identificationValue?: string;
    from: string;
    to: string;
    organizationId?: string;
}
